var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"flex flex-row flex-wrap gap-8"},_vm._l((_vm.kits),function(kit){return _c('li',{key:kit.nkrCode,staticClass:"flex flex-col p-4 border border-gray-300 gap-4 justify-center items-center"},[_c('div',{staticClass:"w-48"},[_c('img',{attrs:{"src":kit.imageRoute,"alt":kit.nkrCode}})]),_c('div',[_c('router-link',{staticClass:"text-blue-500",attrs:{"to":{
            name: 'ProductPage',
            params: {
              productCode: kit.kitNkrCode
            }
          },"target":"_blank"}},[_vm._v(" "+_vm._s(kit.kitNkrCode)+" ")])],1),_c('div',[_vm._v(" "+_vm._s(kit.name)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }